import { useCallback, useEffect, useState } from 'react';

/* Light/dark for the landing page. The choice is remembered per browser;
   with no saved choice the page starts light. data-theme sits on <html>
   only while the landing page is mounted, so other marketing pages keep
   their light design. index.html applies a saved dark choice before first
   paint to avoid a flash. */
const KEY = 'fos-theme';
const THEME_COLOR = { light: '#f6f1e6', dark: '#0a0e13' };

function readSaved() {
  try { return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'; } catch { return 'light'; }
}

export default function useTheme() {
  const [theme, setTheme] = useState(readSaved);

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') root.setAttribute('data-theme', 'dark');
    else root.removeAttribute('data-theme');
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLOR[theme]);
  }, [theme]);

  useEffect(() => () => {
    document.documentElement.removeAttribute('data-theme');
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLOR.light);
  }, []);

  const toggle = useCallback(() => {
    setTheme((t) => {
      const next = t === 'dark' ? 'light' : 'dark';
      try { localStorage.setItem(KEY, next); } catch { /* private mode: still flips for this visit */ }
      return next;
    });
  }, []);

  return [theme, toggle];
}
